import { useQuery } from '@tanstack/react-query';

import { api } from '../../../lib/api-client';

import type { SupervisorDashboardState } from '../types';

export const SUPERVISOR_DASHBOARD_QUERY_KEY = ['supervisor-dashboard', 'state'] as const;

export function useSupervisorDashboard(enabled = true): {
  data: SupervisorDashboardState | undefined;
  isLoading: boolean;
  isError: boolean;
  error: unknown;
  refetch: () => void;
} {
  const query = useQuery({
    queryKey: SUPERVISOR_DASHBOARD_QUERY_KEY,
    queryFn: () => api.getSupervisorDashboardState(),
    enabled,
    staleTime: 30 * 1000,
  });
  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: () => void query.refetch(),
  };
}
